<div id="DL-label">
    <label class="font-weight-bold">{{'LABEL'}}</label>
    <auto-complete width="100%" [searchProps]="autoCompleteSearchProps" [endpointUrl]="labelsEndpoint"
        [disabled]="labelsControl.disabled" [limit]="maxLabelShown" [responseMapper]="responseMapper"
        (onSelect)="onSelect($event)">
    </auto-complete>
    <div class="margin-top-5">
        <span class="chip-container" *ngFor="let label of selectedLabels">
            <acl-ngx-chip [text]="label" (click)="removeLabel($event, label)"></acl-ngx-chip>
        </span>
    </div>
</div>